import * as actions from './actions'

export default function initReducer(appReducer) {
  return function(state, action) {
    if (action.type === actions.RESET_ALL_REDUCER_STATE) {
      return appReducer({}, action)
    }
    if (action.type === actions.RESET_ONE_REDUCER_STATE) {
      if (typeof action.reducerName === 'string') {
        return appReducer(
          {
            ...state,
            [action.reducerName]: appReducer({}, action)[action.reducerName]
          },
          action
        )
      }
    }
    return appReducer(state, action)
  }
}

export { actions as initActions }
